import { addCommasToNumber } from '../../../../Utils/CommonUtils';
import { IAccordionHeader, ITableDataRow } from '../../types';
import { getFormula } from '../../utils';
import { RETURN_EMI_MONTHLY_DATA } from './monthlyEmi';

interface IProps {
  headers: IAccordionHeader[] | undefined;
}

export const getYearWiseData = (props: IProps) => {
  const { headers = [] } = props;
  const datas = [];
  let rows: ITableDataRow[] = [];

  const yearWiseEmiDetails: RETURN_EMI_MONTHLY_DATA[] = getFormula(
    'EMI_MONTHLY_DETAILS',
    {
      ...props,
    }
  );

  let currentYear = '';

  yearWiseEmiDetails?.forEach((monthData) => {
    const { year, ...rest } = monthData;

    if (year !== currentYear) {
      // If the year changes, create a new accordion item
      if (rows.length > 0) {
        datas.push({
          type: 'accordion',
          title: currentYear,
          data: [
            {
              type: 'table',
              data: [
                {
                  headers: headers,
                  rows: rows,
                },
              ],
            },
          ],
        });
        rows = []; // Reset rows for the next year
      }
      currentYear = year; // Update the current year
    }

    // Construct row values for the month
    const rowValues = headers.map((item) => {
      return {
        value: addCommasToNumber(rest[item.id], 0) || 0,
        className: 'bg-white',
      };
    });

    rows.push({
      data: rowValues,
    });
  });

  // Push the last set of rows for the last year
  if (rows.length > 0) {
    datas.push({
      type: 'accordion',
      title: currentYear,
      data: [
        {
          type: 'table',
          data: [
            {
              headers: headers,
              rows: rows,
            },
          ],
        },
      ],
    });
  }

  return datas;
};
